import { marriageSchemaObject } from 'shell/constants/create-schema-marriage';
import { PageMode } from 'civil-status/view-models/page-mode';
import * as yup from 'yup';
import { ObjectShape } from 'yup/lib/object';

const createSchema = (mode: PageMode): yup.ObjectSchema<ObjectShape> => {
  let schemaObject: ObjectShape = {};

  if (mode === PageMode.Edit) {
    schemaObject = marriageSchemaObject;
  }

  return yup.object().shape(schemaObject);
};

export default createSchema;
